export const convertTree = (list) => {
    let map = {}, node, roots = [], i

    for (i = 0; i < list.length; i += 1) {
        map[list[i].deptId] = i // initialize the map
        list[i].children = [] // initialize the children
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i]

        if (node.parentId !== null && !!list[map[node.parentId]]) {
            // if you have dangling branches check that map[node.parentId] exists
            list[map[node.parentId]]?.children.push({
                ...node,
                title: node.deptName,
                key: node.deptId,
                value: node.deptId
            })
        } else {
            roots.push({...node, title: node.deptName, key: node.deptId, value: node.deptId})
        }
    }

    return roots
}

export const convertTreeUser = (list) => {
    let map = {}, node, roots = [], i

    for (i = 0; i < list.length; i += 1) {
        map[list[i].deptId] = i // initialize the map
        list[i].children = [] // initialize the children
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i]

        if (node.parentId !== null && !!list[map[node.parentId]]) {
            // if you have dangling branches check that map[node.parentId] exists
            list[map[node.parentId]].children.push({
                ...node,
                title: node.deptName,
                key: node.deptId,
                value: node.deptId
            })
        } else {
            roots.push({...node, title: node.deptName, key: node.deptId, value: node.deptId})
        }
    }

    roots.push({
        deptCode: "",
        deptName: "All",
        description: "",
        level: 0,
        parentId: null,
        status: 1,
        title: 'All',
        key: '',
        value: ''
    })

    return roots
}
